export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';

export const SHOW_SEARCHBAR = 'SHOW_SEARCHBAR';
export const HIDE_SEARCHBAR = 'HIDE_SEARCHBAR';

export const SET_ISLOGIN = 'SET_ISLOGIN';
export const SET_ISNOTLOGIN = 'SET_ISNOTLOGIN';

export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILED = 'FETCH_USER_FAILED';

export const FETCH_CART = 'FETCH_CART';
export const FETCH_UPDATED_CART_SUCCESS = 'FETCH_UPDATED_CART_SUCCESS';
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS';
export const FETCH_CART_FAILED = 'FETCH_CART_FAILED';
export const ADD_TO_CART = 'ADD_TO_CART';

export const FETCH_COURSE = 'FETCH_COURSE';
export const FETCH_COURSE_SUCCESS = 'FETCH_COURSE_SUCCESS';
export const FETCH_COURSE_FAILED = 'FETCH_COURSE_FAILED';

export const FETCH_COURSE_BY_LESSON = 'FETCH_COURSE_BY_LESSON';
export const FETCH_COURSE_BY_LESSON_SUCCESS = 'FETCH_COURSE_BY_LESSON_SUCCESS';
export const FETCH_COURSE_BY_LESSON_FAILED = 'FETCH_COURSE_BY_LESSON_FAILED';

export const FETCH_LESSON = 'FETCH_LESSON';
export const FETCH_LESSON_SUCCESS = 'FETCH_LESSON_SUCCESS';
export const FETCH_LESSON_FAILED = 'FETCH_LESSON_FAILED';

export const FETCH_USER_LIST = 'FETCH_USER_LIST';
export const FETCH_USER_LIST_SUCCESS = 'FETCH_USER_LIST_SUCCESS';
export const FETCH_USER_LIST_FAILED = 'FETCH_USER_LIST_FAILED';

export const FETCH_COURSE_LIST = 'FETCH_COURSE_LIST';
export const FETCH_COURSE_LIST_SUCCESS = 'FETCH_COURSE_LIST_SUCCESS';
export const FETCH_COURSE_LIST_FAILED = 'FETCH_COURSE_LIST_FAILED';

export const FETCH_SUBJECT_LIST = 'FETCH_SUBJECT_LIST';
export const FETCH_SUBJECT_LIST_SUCCESS = 'FETCH_SUBJECT_LIST_SUCCESS';
export const FETCH_SUBJECT_LIST_FAILED = 'FETCH_SUBJECT_LIST_FAILED';

export const FETCH_INVOICE_LIST = 'FETCH_INVOICE_LIST';
export const FETCH_INVOICE_LIST_SUCCESS = 'FETCH_INVOICE_LIST_SUCCESS';
export const FETCH_INVOICE_LIST_FAILED = 'FETCH_INVOICE_LIST_FAILED';

export const FETCH_INVOICE_LEARNER_LIST = 'FETCH_INVOICE_LEARNER_LIST';
export const FETCH_INVOICE_LEARNER_LIST_SUCCESS = 'FETCH_INVOICE_LEARNER_LIST_SUCCESS';
export const FETCH_INVOICE_LEARNER_LIST_FAILED = 'FETCH_INVOICE_LEARNER_LIST_FAILED';

export const FETCH_INVOICE_LECTURER_LIST = 'FETCH_INVOICE_LECTURER_LIST';
export const FETCH_INVOICE_LECTURER_LIST_SUCCESS = 'FETCH_INVOICE_LECTURER_LIST_SUCCESS';
export const FETCH_INVOICE_LECTURER_LIST_FAILED = 'FETCH_INVOICE_LECTURER_LIST_FAILED';

export const FETCH_INVOICE_LEARNER_LESSON_LIST = 'FETCH_INVOICE_LEARNER_LESSON_LIST';
export const FETCH_INVOICE_LEARNER_LESSON_LIST_SUCCESS = 'FETCH_INVOICE_LEARNER_LESSON_LIST_SUCCESS';
export const FETCH_INVOICE_LEARNER_LESSON_LIST_FAILED = 'FETCH_INVOICE_LEARNER_LESSON_LIST_FAILED';

export const FETCH_COURSE_LECTURER_LIST = 'FETCH_COURSE_LECTURER_LIST';
export const FETCH_COURSE_LECTURER_LIST_SUCCESS = 'FETCH_COURSE_LECTURER_LIST_SUCCESS';
export const FETCH_COURSE_LECTURER_LIST_FAILED = 'FETCH_COURSE_LECTURER_LIST_FAILED';

export const FETCH_SUGGESTION_COURSES = 'FETCH_SUGGESTION_COURSES';
export const FETCH_SUGGESTION_COURSES_SUCCESS = 'FETCH_SUGGESTION_COURSES_SUCCESS';
export const FETCH_SUGGESTION_COURSES_FAILED = 'FETCH_SUGGESTION_COURSES_FAILED';

export const FETCH_DISCOUNT_SUCCESS = 'FETCH_DISCOUNT_SUCCESS';
export const FETCH_DISCOUNT_FAILED = 'FETCH_DISCOUNT_FAILED';

export const FETCH_PROGRESS = 'FETCH_PROGRESS';
export const FETCH_PROGRESS_SUCCESS = 'FETCH_PROGRESS_SUCCESS';
export const FETCH_PROGRESS_FAILED = 'FETCH_PROGRESS_FAILED';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const UPDATE_USER = 'UPDATE_USER';
export const CREATE_COURSE = 'CREATE_COURSE';
export const UPDATE_COURSE = 'UPDATE_COURSE';
export const CREATE_LESSON = 'CREATE_LESSON';
export const UPDATE_LESSON = 'UPDATE_LESSON';
export const CREATE_DISCOUNT = 'CREATE_DISCOUNT';
export const UPDATE_DISCOUNT = 'UPDATE_DISCOUNT';
export const UPDATE_CART = 'UPDATE_CART';
export const CREATE_INVOICE = 'CREATE_INVOICE';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const CHANGE_PASSWORD_WITHOUT_CONFIRM = 'CHANGE_PASSWORD_WITHOUT_CONFIRM';
export const CREATE_FEEDBACK = 'CREATE_FEEDBACK';
export const UPDATE_FEEDBACK = 'UPDATE_FEEDBACK';

export const ADD_PROGRESS = 'ADD_PROGRESS';

export const FETCH_FEEDBACK_SUCCESS = 'FETCH_FEEDBACK_SUCCESS';
export const FETCH_FEEDBACK_FAILED = 'FETCH_FEEDBACK_FAILED';

export const HEADER_VISIBILITY = 'HEADER_VISIBILITY';
export const FOOTER_VISIBILITY = 'FOOTER_VISIBILITY';

export const CREATE_COMMENT = 'CREATE_COMMENT';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const FETCH_COMMENT_SUCCESS = 'FETCH_COMMENT_SUCCESS';
export const FETCH_COMMENT_FAILED = 'FETCH_COMMENT_FAILED';

export const SET_COUNT_UNREAD_MESSAGES = 'SET_COUNT_UNREAD_MESSAGES';
export const SET_RECENT_LIST = 'SET_RECENT_LIST';
export const SET_UNREAD_MESSAGES = 'SET_UNREAD_MESSAGES';
export const SET_STATUS_USER = 'SET_STATUS_USER';
export const SET_RECIPIENT = 'SET_RECIPIENT';
export const SET_CONVERSATIONS = 'SET_CONVERSATIONS';
export const SET_POPUP_CHAT = 'SET_POPUP_CHAT';
export const IS_SET_ROLE = 'IS_SET_ROLE';
